import { render, staticRenderFns } from "./AdminGrowthComponent.vue?vue&type=template&id=4cf17da8"
import script from "./AdminGrowthComponent.vue?vue&type=script&lang=js"
export * from "./AdminGrowthComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports